import type { StaffUser } from '@/types/staff-user'
import { STAFF_PERMISSIONS } from './permissions'
import { normalizeStaffPermissionList } from './staff-permission-list'

/** Display policy only; the runtime validates every privileged request. */
export function isSystemAccount(user: StaffUser | null | undefined): boolean {
  return user?.systemAccountKey === 'system_admin' || user?.role?.name === 'tr_system_admin'
}

export function hasSystemAdminAccess(user: StaffUser | null | undefined, now = Date.now()): boolean {
  const session = user?.systemAdminSession
  return user?.systemAccountKey === 'system_admin'
    && user.role?.name === 'tr_system_admin'
    && !user.vendorImpersonation
    && user.vendorScope?.mode !== 'restricted'
    && session?.staffUserId === user.id
    && session.actorRole === 'cp_platform_owner'
    && Date.parse(session.startedAt) <= now
    && Date.parse(session.expiresAt) > now
}

export function staffHasPermission(user: StaffUser | null | undefined, permission: string): boolean {
  if (permission === STAFF_PERMISSIONS.automationsManage) return hasSystemAdminAccess(user)
  const list = normalizeStaffPermissionList(user?.role?.permissions)
  return list.includes('*') || list.includes(permission)
}

/** Cleanup spans the entire tenant, so vendor-scoped sessions are excluded. */
export function hasSandboxCleanupAccess(user: StaffUser | null | undefined): boolean {
  if (!user || user.vendorImpersonation || user.vendorScope?.mode === 'restricted') return false
  return isSystemAccount(user)
    ? hasSystemAdminAccess(user)
    : normalizeStaffPermissionList(user.role?.permissions).includes('*')
}
